import React from 'react'

export const InvalidBetsMessage = () => {
  return <div>Error: Unable to proceed as bets are invalid</div>
}
